import { useCallback, useRef, useState } from "react";

export function useTimedToggle(delay: number) {
  const [active, setActive] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const toggle = useCallback(() => {
    setActive(true);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setActive(false);
      timeoutRef.current = null;
    }, delay);
  }, [delay]);

  const off = useCallback(() => {
    setActive(false);
  }, []);

  return {
    active,
    toggle,
    off,
  };
}
